import { createAction } from 'redux-actions';
import { createSuccessAction, createFailureAction } from 'utilities/request';

export const requestPatientQuestionnaireResponse = createAction(
  'REQUEST/PATIENT_QUESTIONNAIRE_RESPONSE',
);
export const requestPatientQuestionnaireResponseSuccess = createSuccessAction(
  requestPatientQuestionnaireResponse,
);
export const requestPatientQuestionnaireResponseFailure = createFailureAction(
  requestPatientQuestionnaireResponse,
);

export const patientQuestionnaireInit = createAction('PATIENT_QUESTIONNAIRE/INIT');
